import i18next from 'i18next';
import pt from './translations/pt-br.json';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'pt',
  resources: {
    pt,
  },
});

export default i18next;
